import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFieldComponentProps, setRef } from '@sheerid/jslib';

const CaptainsCircleComponent = ({ value, isErrored, onChange, placeholder = '', errorId }: FormFieldComponentProps) => {
    return (
        <div className="sid-field sid-captains-circle">
            <div className="sid-l-space-top-md" />
                <label htmlFor="sid-captains-circle">
                    <div className={`sid-field__label sid-l-space-btm-sm
                                    ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                        <FormattedHTMLMessage
                            id="captainsCircleNumber"
                            defaultMessage="Captains Circle Number (CCN)"
                        />
                    </div>
                </label>
                <input
                    className={
                        `sid-text-input sid-text-input--required
                            sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                    }
                    id="sid-captains-circle"
                    name="sid-captains-circle"
                    aria-label={'Captains Circle Number'}
                    aria-required={false}
                    aria-describedby={`captainsCircleExplanation ${isErrored ? 'invalidCaptainsNumber' : ''}`}
                    type="text"
                    maxLength={10}
                    minLength={9}
                    pattern="[a-zA-Z0-9]*"
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    placeholder={placeholder}
                    ref={input => setRef('captainsCircleNumber', input as HTMLInputElement)}
                />
                {
                    isErrored && (
                            <div className="sid-field-error" id={`${errorId}`}>
                                <FormattedHTMLMessage
                                    id={`errorId.${errorId}`}
                                    defaultMessage="Missing Captains Circle Number"
                                />
                            </div>
                    )
                }
                <label htmlFor="captainsCircleExplanation">
                    <div className="sid-field-captains-circle-explanation" id="captainsCircleExplanation">
                        <FormattedHTMLMessage
                            id="captainsCircleExplanation"
                            defaultMessage={
                                `If you are registered with Princess and have a CCN,
                                please input your number here. If you are not registered,
                                a CCN will be created for you upon verification.`
                            } />
                    </div>
                </label>
        </div>
    );
};

export { CaptainsCircleComponent };
